export const getACMHeaders = projectScope => {
  const headers = {
    'x-ads-acm-check-groups': 'true'
  };
  if (projectScope && projectScope.length) {
    headers['x-ads-acm-scopes'] = projectScope.join(',');
  }
  return headers;
};
